import { Screen } from '@bonanza-social/navigation';
import CommunityJackpotClaim from '../../components/CommunityJackpotClaim/CommunityJackpotClaim';

function CommunityJackpotClaimScreen() {
  return (
    <Screen paddingBottom="safe-area-inset-bottom" paddingHorizontal="space-0">
      <CommunityJackpotClaim flex={1} paddingTop="space-400" />
    </Screen>
  );
}

export default CommunityJackpotClaimScreen;
